import { ModalBody, Modal, ModalContent, ModalFooter, useDisclosure, Button, Input } from "@heroui/react"
import { useEffect, useRef, useState } from "react"
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks"
import { apiRoute } from "../constants/enum"
import { toast } from "react-toastify"

const ConfirmBox = ({ handleConfirmBox }) => {
    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()

    const inpref = useRef(null)
    const [admKey, setAdmkey] = useState("")
    const [msg, setMsg] = useState("")
    const { isPending, data: admData = [], mutate: funValidateKey } = usePost({
        url: apiRoute.fetchAdmPassword,
        queryKey: "fetchAdmData",
        onSuccessTasks: ((data) => {
            setMsg("")
            if (data && data.length > 0) {
                if (data[0].keyMatch == 1) {
                    handleConfirmBox(true)
                    onOpenReportModelChange();
                }
                else {
                    setMsg("Invalid Auhtentication Key")
                }
            }
            else {
                handleConfirmBox(false)
                onOpenReportModelChange();
            }
        })

    })
    const handleDelete = (e) => {
        // e.preventDefault()
        // if (admKey != "" && admKey != null) {
        //     funValidateKey({
        //         data: {
        //             adm_key: admKey
        //         }
        //     })
        // }
        // else {
        //     setMsg("Authentication Key Required")
        //     if (inpref.current)
        //         inpref.current.focus();
        // }
         handleConfirmBox(true)
         onOpenReportModelChange();
    }

    const handleOnClose = () => {
        handleConfirmBox(false);
        onOpenReportModelChange();
    }

    useEffect(() => {
        onOpenReportModelChange()
    }, [handleConfirmBox])



    return (
        <div>
            <Modal
                isOpen={isOpenReportModel}
                onOpenChange={onOpenReportModelChange}
                size="xs"
                placement="center"
                backdrop="transparent"
                isDismissable={false}
                hideCloseButton={true}
            >
                <ModalContent>
                    {(onClose) => (
                        // <form  onSubmit={handleDelete}>
                        <>
                            <ModalBody className="overflow-auto border-t-4 border-rose-500">
                                <div className="flex  item-center justify-around text-sm mt-5 mb-2" > Sure ! You Want To Delete?</div>
                                {/* <div className=" text-green-700 font-semibold item-center justify-around text-xs mt-3 " >
                                    Enter Authentication Key To Confirm Action</div>
                                <div className="text-red-500 text-sm" >{msg}</div>
                                <div className="p-1 bg-red-100">
                                    <Input ref={inpref} type="password" size="sm" color="danger" variant="underlined" className="bg-white" isRequired value={admKey} onChange={
                                        (e) => setAdmkey(e.target.value)
                                    } name="admKey" ></Input>
                                </div> */}
                            </ModalBody>
                            <ModalFooter>


                                <Button color="warning" size="sm" variant="bordered"  onPress={handleDelete}>
                                    Yes Delete !
                                   {/* Submit Action */}
                                </Button>
                                <Button color="danger" size="sm" variant="bordered" onPress={handleOnClose}>
                                    Cancle
                                </Button>
                            </ModalFooter>

                        </>
                    )}
                </ModalContent>
            </Modal>
        </div>
    )
}
 export default ConfirmBox